<template>
  <div>
    <title-bar title="MODBUS测试">
      <el-button type="primary" icon="fa fa-refresh" @click="query">刷新</el-button>
    </title-bar>
    <div class="page-body">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-card header="在线设备" body-style="max-height: 500px;overflow-y:auto">
            <div class="modbus-item" v-for="item in records" :key="item.id"
                 @click="handleClick(item)">
              <div>
                <div class="modbus-item-id">
                  {{ item.deviceCode || item.id }}
                </div>
                <div class="modbus-item-address">
                  {{ item.address }}
                </div>
              </div>
              <i class="fa fa-check-circle color-primary" v-if="currentItem != null && currentItem.id == item.id"></i>
            </div>
            <span v-if="records.length==0">
              没有在线设备
            </span>
          </el-card>
        </el-col>
        <el-col :span="16" v-if="currentItem != null">
          <el-card header="消息" body-style="height: 300px;overflow-y:auto">
            <div :class="'message-item ' + (message.type=='s'?'color-primary':'color-success')"
                 v-for="message in messages"
                 :key="message.time">
              <span>{{message.time }}</span>
              <span style="margin-left: 20px">{{message.message}}</span>
            </div>
          </el-card>
          <el-form inline style="margin-top: 20px">
            <el-form-item label="发送消息">
              <el-input v-model="msg" type="text" style="width: 300px"></el-input>
            </el-form-item>
            <el-button type="primary" @click="send">发送命令</el-button>
            <el-button type="primary" @click="readRegisters">读取寄存器</el-button>
            <el-button type="primary" @click="readCoils">读取线圈</el-button>
          </el-form>
          <el-form inline style="margin-top: 20px">
            <el-form-item label="设备编号">
              <el-input v-model="deviceCode" placeholder="如GY-20230801-00005" type="text" style="width: 300px"></el-input>
            </el-form-item>
            <el-button type="primary" @click="modifyDeviceCode">修改设备编号</el-button>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
export default {
  components: {TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      socket: null,
      currentItem: null,
      msg: '',
      deviceCode: '',
      messages: [],
      records: []
    }
  },
  created() {
    this.query();
  },
  beforeDestroy() {
    if(this.socket != null) {
      this.socket.close();
    }
  },
  methods: {
    query(){
      this.currentItem = null;
      this.messages = [];
      this.records = [];
      this.loading = true;
      this.postForm("/modbus/list", null, true).then(dr => {
        this.records = dr.rows;
      }).finally(()=>{
        this.loading = false;
      })
    },
    handleClick(item) {
      if(this.currentItem && this.currentItem.id == item.id) {
        return;
      }
      this.currentItem = item;
      this.listenSocket();
    },
    send(){
      this.loading = true;
      this.postForm("/modbus/send-command",{
        id: this.currentItem.id,
        command: this.msg
      }, true);
    },
    readRegisters(){
      this.loading = true;
      this.postForm("/modbus/read-registers",{
        id: this.currentItem.id
      }, true);
    },
    readCoils(){
      this.loading = true;
      this.postForm("/modbus/read-coils",{
        id: this.currentItem.id
      }, true);
    },
    modifyDeviceCode(){
      this.loading = true;
      this.postForm("/modbus/set-device-code",{
        id: this.currentItem.id,
        deviceCode: this.deviceCode
      }, true);
    },
    listenSocket(){
      if(this.socket != null) {
        this.socket.close();
      }
      if(!this.currentItem) {
        return;
      }
      console.log("开启socket监听");
      this.socket = new WebSocket(this.globalConfig.wsRoot+"/modbus-test/"+this.currentItem.id);
      this.socket.onmessage = (e)=>{
        let bean = JSON.parse(e.data);
        console.log(bean);
        this.messages.push(bean);
      }
      this.socket.onclose = () => {
        console.log("socket is closed");
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/css/variables";
.modbus-item{
  line-height: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modbus-item+.modbus-item{
  border-top: 1px solid $color-border-primary
}
.message-item{
  padding: 10px;
}
</style>